import React, { Component } from 'react';
import { Row, Col, FormGroup, Radio } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import getContent from './Contents/NameLikeness';

export default class NameLikeness extends Component {
  options = () => ({
    field1: this.props.field1,
  });

  handleContent(index) {
    const options = this.options();

    options.field1 = index;
    this.props.updateBlock(this.props.block.id, getContent(options), options);
  }

  render() {
    return (
      <div className="tab-content">
        <Row>
          <Col sm={12}>
            <p className="question">
              How can collaborators use the name and likeness of the others?
            </p>
            <FormGroup className="answer">
              <Radio
                name="name-likeness"
                checked={this.props.field1 === 0}
                readOnly
                onClick={(e) => this.handleContent(0)}
              >
                Only when providing a credit. In other cases, collaborators need
                written permission each time before using the names, likeness,
                trademarks, or biographical information of another collaborator.
              </Radio>
              <Radio
                name="name-likeness"
                checked={this.props.field1 === 1}
                readOnly
                onClick={(e) => this.handleContent(1)}
              >
                Collaborators can use the names, likeness, trademarks, or
                biographical information of another collaborator without having
                to get written permission each time, as long as it's used in a
                way that relates to the sale, license, or promotion of the
                work(s).
              </Radio>
            </FormGroup>
          </Col>

          <Col sm={12}>{this.props.children}</Col>

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  A collaborator's name and likeness can include their name,
                  monikers, images, and trademarks that represent themselves.
                  Taking the time now to state when collaborators need to get
                  permission from each other to use these things can help you to
                  complete deals efficiently and to avoid issues of
                  misrepresentation in the future.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/ContractBlock/NameLikeness.jsx